// react-frontend/src/store/forms/delForm/clientSignatures/actions.js
// forms/delForm/clientSignatures

import { DelClientSignatures } from "../../../../models/Del/DelClientSignatures";

export const makeClientSignaturesActions = ({
  getDraft,
  bump,
  setClientSignaturesUi,
}) => ({
  toggleClientSignaturesRequired() {
    const draft = getDraft();
    draft.projectInfo.clientSignaturesRequired =
      !draft.projectInfo.clientSignaturesRequired;
    bump();
  },

  addNewBlankClientSignature(emitPatch) {
    const draft = getDraft();
    const newRowId = draft.addNewBlankClientSignature();
    // Finding the new client signature
    const newSignature =
      draft.clientSignatures.find((c) => c.rowId === newRowId) || null;
    const patch = newSignature.toPatch("add", {
      rowId: newSignature.rowId,
    });
    emitPatch(patch);
    bump();
    return newRowId;
  },

  removeClientSignature(rowId, emitPatch) {
    const draft = getDraft();
    const signatureItem =
      draft.clientSignatures.find((c) => c.rowId === rowId) || null;
    const patch = signatureItem.toPatch("remove", {
      rowId: signatureItem.rowId,
    });
    emitPatch(patch);
    draft.removeClientSignature(rowId);

    bump();
  },

  updateClientSignatureName(rowId, value) {
    const draft = getDraft();
    const item = draft.clientSignatures.find((c) => c.rowId === rowId) || null;
    if (item) item.updateClientEmpName(value);
    bump();
  },

  updateClientSignatureTitle(rowId, value) {
    const draft = getDraft();
    const item = draft.clientSignatures.find((c) => c.rowId === rowId) || null;
    if (item) item.updateClientEmpTitle(value);
    bump();
  },

  updateClientSignatureCompany(rowId, value) {
    const draft = getDraft();
    const item = draft.clientSignatures.find((c) => c.rowId === rowId) || null;
    if (item) item.updateClientCompanyName(value);
    bump();
  },

  openSignatureModal(rowId) {
    const draft = getDraft();
    const current =
      draft.clientSignatures.find((c) => c.rowId === rowId) || null;
    setClientSignaturesUi({
      signatureModalOpen: true,
      currentSignatureRowId: rowId,
      currentSignatureImage: current?.clientEmpSig || null,
      currentSignatureName: current?.clientEmpName || null,
      currentSignatureTitle: current?.clientEmpTitle || null,
      currentSignatureCompany: current?.clientCompanyName || null,
    });
    bump();
  },

  closeSignatureModal() {
    setClientSignaturesUi({
      signatureModalOpen: false,
      currentSignatureRowId: null,
      currentSignatureImage: null,
      currentSignatureName: null,
      currentSignatureTitle: null,
      currentSignatureCompany: null,
    });
    bump();
  },

  saveSignature(signatureData, rowId, name, title, company, emitPatch) {
    const draft = getDraft();
    const item = draft.clientSignatures.find((c) => c.rowId === rowId) || null;
    if (item) {
      item.updateClientEmpSig(signatureData || "");
      item.updateClientEmpName(name || "");
      item.updateClientEmpTitle(title || "");
      item.updateClientCompanyName(company || "");
    }
    // Patching the client signatures section
    const patch = item.toPatch("update", {
      rowId: rowId,
      clientEmpSig: signatureData || "",
      clientEmpName: name || "",
      clientEmpTitle: title || "",
      clientCompanyName: company || "",
    });
    emitPatch(patch);
    // Note: SignatureModal passes null on clear, and dataURL on save
    setClientSignaturesUi({
      signatureModalOpen: false,
      currentSignatureRowId: null,
      currentSignatureImage: null,
      currentSignatureName: null,
      currentSignatureTitle: null,
      currentSignatureCompany: null,
    });
    bump();
  },

  handleBroadcast(patch) {
    const draft = getDraft();
    if (!draft) return;

    const { id, action } = patch;

    if (action === "remove") {
      const idx = draft.clientSignatures.findIndex((s) => s.rowId === id);
      if (idx >= 0) {
        draft.clientSignatures.splice(idx, 1);
        bump();
      }
      return;
    }

    // Handle add/update - find existing or create new
    const existing = draft.clientSignatures.find((s) => s.rowId === id);
    if (existing) {
      // Update existing signature with explicit field mapping
      // (signature field needs special handling for base64 prefix)
      if (patch.client_emp_name !== undefined) {
        existing.clientEmpName = patch.client_emp_name;
      }
      if (patch.client_emp_title !== undefined) {
        existing.clientEmpTitle = patch.client_emp_title;
      }
      if (patch.client_company_name !== undefined) {
        existing.clientCompanyName = patch.client_company_name;
      }
      if (patch.client_emp_sig !== undefined) {
        existing.clientEmpSig = patch.client_emp_sig
          ? "data:image/png;base64," + patch.client_emp_sig
          : "";
        existing.saveStatus = patch.client_emp_sig ? "saved" : "pending";
      }
      bump();
    } else {
      // Create new signature from broadcast data
      const newSig = new DelClientSignatures(patch);
      draft.clientSignatures.push(newSig);
      bump();
    }
  },
});
